module.exports = __webpack_public_path__ + "static/media/08.8d8dbf8c.jpg";